/*  MUI  */
import { Paper } from '@mui/material';
import { SessionHelper } from 'application/Shared/Helpers';

/* Hooks */
import { useSession } from 'hooks/redux/Selectors/session';

/*  React  */
import React from 'react';
import { Navigate, useLocation } from 'react-router';

/*  Components  */
import { ConfigureSelfUser } from './ConfigureSelfUser/ConfigureSelfUser';

export const UserSetup = () => {
    const session = useSession();
    const sessionHelper = new SessionHelper(session);
    const user = sessionHelper.getUser();

    const location = useLocation();
    const { search } = location;

    if (user.configured && user.tos) {
        return <Navigate to={{ pathname: '/home', search }} replace />;
    }

    return (
        <Paper elevation={0} variant="outlined" sx={{ p: '16px' }}>
            <ConfigureSelfUser initialSetup />
        </Paper>
    );
};
